<div class="flex flex-row items-start justify-between lendio-density-2">
    <mat-form-field appearance="outline" hideRequiredMarker="true">
        <mat-icon matPrefix>search</mat-icon>
        <input
            matInput
            type="text"
            placeholder="Search"
            [(ngModel)]="quickFilterValue"
            (ngModelChange)="onQuickFilterChange()">
        <div matSuffix>
            <button (click)="clear()" mat-icon-button>
                <mat-icon class="text-sm leading-[1.75]">close</mat-icon>
            </button>
        </div>
    </mat-form-field>
    <button [matTooltip]="'Sort by date'" class="mt-1">
        <button *ngIf="sorted" (click)="applySort()">
            <mat-icon *ngIf="sortDirection === 'asc'">arrow_upward</mat-icon>
            <mat-icon *ngIf="sortDirection === 'desc'">arrow_downward</mat-icon>
        </button>
        <button *ngIf="!sorted" (click)="applySort()">
            <mat-icon>swap_vert</mat-icon>
        </button>
    </button>
</div>
